var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPriorityLow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#3ADAE5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4786 11.6743H9.51863L9.26863 6.7643H10.7286L10.4786 11.6743ZM9.22863 13.2643C9.22863 12.9843 9.30197 12.7876 9.44863 12.6743C9.5953 12.5543 9.77863 12.4943 9.99863 12.4943C10.1986 12.4943 10.3753 12.5543 10.5286 12.6743C10.682 12.7876 10.7586 12.9843 10.7586 13.2643C10.7586 13.5376 10.682 13.7343 10.5286 13.8543C10.3753 13.9743 10.1986 14.0343 9.99863 14.0343C9.77863 14.0343 9.5953 13.9743 9.44863 13.8543C9.30197 13.7343 9.22863 13.5376 9.22863 13.2643Z",
    fill: "#0D0D0D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriorityLow);
export default __webpack_public_path__ + "static/media/priority-low.388f45d4e7e96480c70628606e402729.svg";
export { ForwardRef as ReactComponent };